import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import DataTable from '../DataTable';
import { toUtc } from '../../libs/date';
import moment from 'moment';

@inject('requestStore')
@observer
class RequestDetailRawDataList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }
  @observable rawData = [];

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id }, requestStore } = this.props;
    const request = requestStore.findById(id);
    const rawData = (request && request.raw_data) || [];
    this.rawData = rawData.map(item => {
      return Object.assign({}, item, {
        time: toUtc(item.time),
      });
    });
  }

  slug = '/request';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'origin_code', label: 'Origin Code' },
    { key: 'parameter_code', label: 'Parameter Code' },
    { key: 'time', label: 'Time' },
    { key: 'value', label: 'Value' },
    { key: 'processed', label: 'Processed' },
  ];

  render() {
    return (
      <DataTable
        data={this.rawData}
        slug={this.slug}
        columns={this.columns}
        readOnly paginate
      />
    );
  }
}

export default RequestDetailRawDataList;



// WEBPACK FOOTER //
// ./src/components/Request/RequestDetailRawDataList.js